import { render, staticRenderFns } from "./PlanejamentoAcaoFormApuracaoIntervalo.vue?vue&type=template&id=39a19456"
import script from "./PlanejamentoAcaoFormApuracaoIntervalo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormApuracaoIntervalo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports